import { render } from "./FileView.vue?vue&type=template&id=8ccbd82e&scoped=true"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"

import "./FileView.vue?vue&type=style&index=0&id=8ccbd82e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccbd82e"]])

export default __exports__